import React from 'react'
import { connect } from 'react-redux'

import { RootStateTypeExtra } from '@store/types'

import Container from '@components/container'
import DataHandler from '@components/data-handler'

import {
  selectFromResult as selectFromLocationResult,
  useGetLocationQuery,
} from '@api/location'

export interface PagePropsInterface {
  projectName: string
}

function Location({ projectName }: PagePropsInterface) {
  const locationPayload = useGetLocationQuery(
    { projectName },
    { selectFromResult: selectFromLocationResult }
  )

  return (
    <Container>
      <div className="h-full w-full px-4">
        <div className="flex h-top-bar w-full items-center justify-center text-neutralColour">
          <div className="text-title font-medium">Location Map</div>
        </div>
        <div className="no-scrollbar h-page-body w-full overflow-auto">
          <DataHandler
            payloads={{
              ...locationPayload,
              data: locationPayload.locationData,
            }}
          >
            Location Page
          </DataHandler>
        </div>
      </div>
    </Container>
  )
}

export default connect(
  ({ projectIdentity: { projectId } }: RootStateTypeExtra) => ({
    projectName: projectId,
  })
)(Location)
